<template>
  <div class="stockOut column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width350">
          <el-select placeholder="请选择单据类型" style="width: 100%;" filterable clearable v-model="selectType">
            <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width350 margin-left20">
          <el-select placeholder="请选择库房" style="width: 100%;" filterable clearable v-model="selectHouse">
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width350 margin-left20">
          <el-input placeholder="请输入单据编号" style="width: 100%;" clearable v-model="number"></el-input>
        </div>
        <div class="width350 margin-left20">
          <el-select placeholder="请选择供应商" style="width: 100%;" filterable clearable v-model="selectApplier">
            <el-option v-for="item in supplierArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="row-me row-center margin-top20">
        <div>开始时间：</div>
        <div class="width260">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="selectDate1">
          </el-date-picker>
        </div>
        <div class="margin-left20">结束时间：</div>
        <div class="width260">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="selectDate2">
          </el-date-picker>
        </div>
        <div class="width250 margin-left20">
          <el-input placeholder="请输入药品名称" style="width: 100%;" clearable v-model="drugName"></el-input>
        </div>
        <div class="flex1"></div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickPrint">
          <el-icon>
            <printer/>
          </el-icon>
          打印
        </div>
        <div class="btn-orange width100 btn-height40 margin-left20" @click="clickExport">导出</div>
      </div>
      <div class="table-border margin-top20">
        <div class="column-me">
          <div>
            <el-table :data="tableData" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style" height="68vh" show-summary
                      :summary-method="getSummaries">
              <el-table-column prop="receiptNo" label="单据编号" align="center" width="200"></el-table-column>
              <el-table-column prop="drugName" label="药品名称" align="center" width="140"></el-table-column>
              <el-table-column prop="supplierName" label="供应商" align="center" width="140">
              </el-table-column>
              <el-table-column prop="producerName" label="生产商" align="center" width="140">
              </el-table-column>
              <el-table-column prop="spec" label="规格" align="center" width="80"></el-table-column>
              <el-table-column prop="unitName" label="单位" align="center" width="80"></el-table-column>
              <el-table-column prop="nums" label="数量" align="center" width="100"></el-table-column>
              <el-table-column prop="costPrice" label="单价" align="center" width="100"></el-table-column>
              <el-table-column prop="totalPrice" label="总价" align="center" width="100"></el-table-column>
              <el-table-column prop="batchNo" label="批号" align="center" width="200"></el-table-column>
              <el-table-column prop="validityTime" label="有效期" align="center" width="130">
              </el-table-column>
              <el-table-column prop="typeName" label="类型" align="center" width="130"></el-table-column>
              <el-table-column prop="createTime" label="出库时间" align="center" width="200">
              </el-table-column>
              <el-table-column prop="produceTime" label="生产日期" align="center" width="150">
              </el-table-column>
              <el-table-column prop="productAddress" label="产地" align="center" width="100">
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 打印 -->
    <div v-show="false">
      <stockOutPrint ref="printPage" :tableData='printData'></stockOutPrint>
    </div>
  </div>
</template>

<script>
import stockOutPrint from './stockOutPrint.vue'

export default {
  components: {
    stockOutPrint
  },
  data() {
    return {
      selectType: '',
      selectHouse: '',
      number: '',
      selectApplier: '',
      selectDate1: '',
      selectDate2: '',
      drugName: '',
      tableData: [],
      typeArray: [],
      houseArray: [],
      supplierArray: [],
      printData: [],
    }
  },
  // html加载完成之前
  created() {
    this.selectDate1 = this.$method.getNowDate()
    this.selectDate2 = this.$method.getNowDate()
    this.getTypeArray()
    this.getHouseList()
    this.getSupplier()
  },
  // html加载完成后执行。
  mounted() {
    this.getData()
  },
  // 事件方法执行
  methods: {
    clickSearch() {
      this.getData()
    },
    clickClear() {
      this.selectType = ''
      this.selectHouse = ''
      this.selectApplier = ''
      this.number = ''
      this.drugName = ''
      this.selectDate1 = this.$method.getNowDate()
      this.selectDate2 = this.$method.getNowDate()
      this.getData()
    },
    //打印
    clickPrint() {
      let tempArray = this.$method.deepClone(this.tableData)
      let sum = {
        batchNo: "",
        costPrice: "",
        createTime: "",
        drugName: "",
        inStorageDetailId: "",
        inStorageId: "",
        nums: this.$method.countTotal(tempArray, 'nums'),
        produceTime: "",
        producerId: "",
        producerName: "",
        productAddress: "",
        receiptNo: "总计",
        spec: "",
        supplierId: "",
        supplierName: "",
        totalPrice: this.$method.countTotal(tempArray, 'totalPrice'),
        type: "",
        typeName: "",
        unitId: "",
        unitName: "",
        validityTime: "",
      }
      tempArray.push(sum)
      this.printData = tempArray
      this.$refs.printPage.startPrint()
    },
    //导出
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        receiptId: this.selectType,
        pharmacyId: this.selectHouse,
        orderNo: this.number,
        supplierId: this.selectApplier,
        start: this.selectDate1,
        end: this.selectDate2,
        name: this.drugName,
        token: token,
      }
      let url = this.$baseUrl + '/admin/statistics/inventoryOutExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //获取数据
    getData() {
      this.$postFormRequest('/admin/statistics/inventoryOutReceipt', {
        receiptId: this.selectType,
        pharmacyId: this.selectHouse,
        orderNo: this.number,
        supplierId: this.selectApplier,
        start: this.selectDate1,
        end: this.selectDate2,
        name: this.drugName,
      }).then((res) => {
        if (res) {
          this.tableData = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取数据
    getTypeArray() {
      this.$getRequest('/admin/statistics/inSelect', {}).then((res) => {
        if (res) {
          this.typeArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取供应商
    getSupplier() {
      this.$getRequest('/admin/supplier/list', {
        supplier: true,
      }).then((res) => {
        if (res) {
          this.supplierArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getSummaries(param) {
      const {
        columns,
        data
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (index === 6 || index === 8) {
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + value;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = this.$method.toFixed(sums[index], 3)
          } else {
            sums[index] = 'N/A';
          }
        }
      });
      return sums;
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.stockOut {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    font-size: 18px;
    color: #252630;
  }
}
</style>
